// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__1VxOO","add":"style_add__1cvwp","actions":"style_actions__UwpOK","actions_btn":"style_actions_btn__D-w6m"};